var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountAddress = function SvgIconAccountAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5 14.417V3.167A2.5 2.5 0 0 1 3 .667h11.667c.46 0 .833.373.833.833v15c0 .46-.373.834-.833.834H3.417A2.917 2.917 0 0 1 .5 14.417m13.333 1.25v-2.5H3.417a1.25 1.25 0 0 0 0 2.5zM2.167 11.781c.379-.18.802-.28 1.25-.28h10.416V2.333H3a.833.833 0 0 0-.833.833z"
  })));
};
export default SvgIconAccountAddress;